import { createRouter, createWebHistory } from "vue-router";
import MainPanel from "@/generator/MainPanel.vue";
import BasicInfo from "@/views/GeneratorBasicInfo.vue";
import Icons from "@/views/GeneratorIcons.vue";
import Options from "@/views/GeneratorOptions.vue";
import Templates from "@/views/GeneratorTemplates.vue";
import Addons from "@/views/GeneratorAddons.vue";
import FeedbackPositive from "@/feedback/FeedbackPositive.vue";
import FeedbackNegative from "@/feedback/FeedbackNegative.vue";
const childrenRoutes = [
  {
    path: "",
    component: Templates,
  },
  {
    path: "templates",
    component: Templates,
  },
  {
    path: "info",
    component: BasicInfo,
  },
  {
    path: "options",
    component: Options,
  },
  {
    path: "icons",
    component: Icons,
  },
  {
    path: "addons",
    component: Addons,
  },
];

const routes = [
  {
    path: "/",
    component: MainPanel,
    children: childrenRoutes,
  },
  {
    path: "/preview/:id",
    component: MainPanel,
    children: childrenRoutes,
  },
  {
    path: "/settings/:id",
    component: MainPanel,
    children: childrenRoutes,
  },
  {
    path: "/dev/:id",
    component: MainPanel,
    children: childrenRoutes,
  },
  { path: "/positive", component: FeedbackPositive },
  { path: "/negative", component: FeedbackNegative },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

export default createRouter({
  history: createWebHistory(),
  routes,
});
